import React, { useState, useEffect } from "react";
import { getRequest, delRequest } from "../../axiosRoutes/index";
import { useNavigate } from "react-router-dom";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Modal,
  Radio,
  FormControlLabel,
  RadioGroup,
  Slider,
  FormControl,
  Button,
  InputBase,
  InputAdornment,
  Box,
  CircularProgress,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  Divider,
  Snackbar,
  Alert,
  Card,
  CardContent,
  CardActions,
  useMediaQuery,
} from "@mui/material";
import Pagination from '@mui/material/Pagination';
import SideNavBar from "../sidebar/SideNav";
import HrSideNavBar from "../sidebar/HrSideNavBar";
import AddEmployee from "./AddEmployee";
import { Search as SearchIcon } from "@mui/icons-material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import UnarchiveIcon from "@mui/icons-material/Unarchive";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArchiveIcon from "@mui/icons-material/Archive";
import { useSnackbar } from "../../axiosRoutes/snackbarConfig";
import { useInView } from 'react-intersection-observer';

const Employees = () => {
  const { snackbar, showSnackbar, handleSnackbarClose } = useSnackbar();
  const navigate = useNavigate();
  const [hover, setHover] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openFilter, setOpenFilter] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [updateId, setUpdateId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [statuses, setStatuses] = useState([]);
  const [statusFilter, setStatusFilter] = useState("active");
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [salaryRange, setSalaryRange] = useState([10000, 500000]);
  const role = localStorage.getItem("role");
  const isSmallScreen = useMediaQuery("(max-width:900px)");
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [departments, setDepartments] = useState([])
  const [isFetchingUser, setIsFetchingUser] = useState(false)
  const { ref, inView } = useInView({
    threshold: 0,
  });
  const [limit, setLimit] = useState(10)

  useEffect(() => {
    if (inView) {
      if(limit < totalPages * 10){
        setLimit(prev=>prev+10)
      }
    }
  }, [inView]);

  const fetchDepartments = async () => {
      try {
        const response = await getRequest("filter/department");
        const departmentArray = Object.keys(response).map((key) => ({
          label: key,
          value: response[key],
        }));
        setDepartments(departmentArray)
      } catch (error) {
        console.error("Error fetching Filter:", error);
      }
    };

  const fetchEmployees = async () => {
    if (departments.length === 0) return;
    const access = localStorage.getItem("access");
    const queryParams = new URLSearchParams();
    if (statusFilter) queryParams.append("status", statusFilter);
    if (searchQuery) queryParams.append("search", searchQuery);
    if (salaryRange[0]) queryParams.append("minSalary", salaryRange[0]);
    if (salaryRange[1]) queryParams.append("maxSalary", salaryRange[1]);
    !isSmallScreen && queryParams.append('page', page)
    isSmallScreen && queryParams.append('limit', limit)
    const url = `employee?${queryParams.toString()}`;
    try {
      isSmallScreen && setIsFetchingUser(true)
      !isSmallScreen && setLoading(true)
      const response = await getRequest(url, {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });
      if (Array.isArray(departments) && departments.length > 0) {
        const deptLookup = Object.fromEntries(
          departments.map((dept) => [dept.value, dept.label])
        );

        response.data = response.data?.map((emp) => ({
          ...emp,
          department: deptLookup[emp.department] ?? emp.department,
        }));
      }
      setEmployees(response?.data)
      setTotalPages(response?.totals?.total_pages)
      isSmallScreen && setIsFetchingUser(false)
    } catch (error) {
      console.error("Error fetching employees:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchStatus = async () => {
    try {
      const response = await getRequest("filter/active");
      const statusArray = Object.keys(response).map((key) => ({
        label: key,
        value: response[key],
      }));
      setStatuses(statusArray);
    } catch (error) {
      console.error("Error fetching Filter:", error);
    }
  };

  

  useEffect(() => {
    fetchDepartments();
    fetchStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit]);

  useEffect(()=>{
    fetchEmployees();
  }, [departments])

  const handleStatusChange = (event) => {
    setStatusFilter(event.target.value);
  };

  const handleSliderChange = (event, newValue) => {
    setSalaryRange(newValue);
  };

  const formatLabel = (value) => {
    return `${value.toLocaleString()} PKR`;
  };

  const handleDelete = async () => {
    try {
      const access = localStorage.getItem("access");
      const response = await delRequest(`employee/${deleteId}`, access);
      fetchEmployees();
      handleClose();
      showSnackbar(response, "success");
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || "An error occurred";
      showSnackbar(errorMessage, "error");
    }
  };

  const handleOpen = () => {
    setOpenModal(true);
  };

  const handleClickOpen = (id) => {
    setDeleteId(id);
    setOpen(true);
  };

  const profile = (id, user) => {
    navigate("/employee/profile", { state: { id, user } });
  };

  const selectEmployee = (id) => {
    setUpdateId(id);
    handleOpen();
  };

  useEffect(() => {
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    if (searchQuery.length >= 3 ) {
      const timeout = setTimeout(() => {
        setPage(1)
        fetchEmployees();
      }, 2000);

      setTypingTimeout(timeout);

      return () => clearTimeout(timeout);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery]);

  useEffect(()=>{
    if(searchQuery === ''){
      setPage(1)
      fetchEmployees()
    }
  }, [searchQuery])

  const handleClose = () => {
    if(statusFilter === 'archived' || salaryRange[0] > 10000 || salaryRange[1] < 500000){
      setPage(1)
    }
    setOpenModal(false);
    setOpen(false);
    setOpenFilter(false);
    setDeleteId(null);
    setUpdateId(null);
    fetchEmployees();
  };

  const headingTableCellStyle = {
    color: "#fff",
    textAlign: "center",
    borderBottom: "2px solid #1F1F1F",
    fontSize: { xs: "0.8rem", sm: "1rem" },
    backgroundColor: '#1F1F1F'
  }

  const dataTableCellStyle = (hover, id) => {
    return {
      color: hover === id ? "#FF5722" : "#fff",
      textAlign: "center",
      borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
      fontSize: { xs: "0.8rem", sm: "1rem" },
      padding: '10px 16px',
      backgroundColor: '#292929'
    };
  };

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100vh"
        textAlign="center"
      >
        <CircularProgress size={50} sx={{ color: "#FF5722" }} />
        <Typography variant="h6" sx={{ marginTop: "18px", color: "#fff" }}>
          Loading...
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <div className="app-container" style={{ color: "#fff", display: "flex" }}>
        {role === "admin" && <SideNavBar />}
        {role === "hr" && <HrSideNavBar />}
        <div style={{ flex: 1, margin: `${isSmallScreen ? '3rem' : '0.5rem'} 0.5rem 0.5rem 0.5rem` }}>
          {!isSmallScreen ? (
            <h1 style={{ padding: " 1rem 1rem 0 1rem", marginBottom: 0 }}>
              Employees
            </h1>
          ) : (
            <h2
              style={{
                padding: " 1rem 1rem 0 1rem",
                marginBottom: 0,
                marginTop: "2rem",
              }}
            >
              Employees
            </h2>
          )}
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            padding="0.5rem 1rem 1rem 1rem"
          >
            <Grid item xs={5.8} md={2}>
              <Paper
                style={{
                  background: "#000",
                  padding: "2px 4px",
                  margin: "10px auto",
                  border: isSmallScreen ? "1px solid white" : "",
                  borderBottom: isSmallScreen
                    ? "1px solid white"
                    : "1px solid white",
                  borderRadius: isSmallScreen ? "10px" : "0",
                }}
              >
                <InputBase
                  style={{ marginLeft: 8, flex: 1, color: "#fff" }}
                  placeholder="Search"
                  inputProps={{ "aria-label": "search" }}
                  startAdornment={
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: "#fff" }} />
                    </InputAdornment>
                  }
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </Paper>
            </Grid>
            <Grid item xs={5.8} md={2} lg={1.5}>
              <IconButton
                style={{
                  color: "#fff",
                  margin: 2,
                }}
                aria-label="view"
                size="medium"
                onClick={() => setOpenFilter(true)}
              >
                <FilterAltOutlinedIcon fontSize="inherit" />
              </IconButton>
              <Button
                variant="contained"
                onClick={handleOpen}
                sx={{
                  marginLeft: "1rem",
                  backgroundColor: "#fff",
                  fontSize: "14px",
                  color: "black",
                  "&:hover": {
                    backgroundColor: "#e1e1e1",
                  },
                }}
              >
                Create
              </Button>
            </Grid>
          </Grid>
          {employees.length === 0 ? (
            <Typography
              variant="h6"
              sx={{ color: "#fff", textAlign: "center" }}
            >
              No Data Yet
            </Typography>
          ) : (
            <>
              {!isSmallScreen ? (
                <TableContainer sx={{ overflowX: "auto", maxWidth: "100vw" }}>
                  <Table
                    style={{
                      borderRadius: "25px",
                      borderCollapse: "separate",
                      overflow: "hidden",
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell style={headingTableCellStyle}>ID</TableCell>
                        <TableCell style={headingTableCellStyle}>
                          Name
                        </TableCell>
                        <TableCell style={headingTableCellStyle}>
                          Email
                        </TableCell>
                        <TableCell style={headingTableCellStyle}>
                          Designation
                        </TableCell>
                        <TableCell style={headingTableCellStyle}>
                          Department
                        </TableCell>
                        <TableCell style={headingTableCellStyle}>
                          CNIC
                        </TableCell>
                        <TableCell style={headingTableCellStyle}>
                          Phone
                        </TableCell>
                        <TableCell style={headingTableCellStyle}>
                          Salary
                        </TableCell>
                        <TableCell style={headingTableCellStyle}>
                          Actions
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {employees.map((employee, id) => (
                        <TableRow
                          key={id}
                          style={{
                            cursor: "pointer",
                            height: '60px'
                          }}
                          onMouseEnter={() => setHover(id)}
                          onMouseLeave={() => setHover(null)}
                          onClick={() =>
                            profile(employee._id, employee.userId._id)
                          }
                        >
                          <TableCell style={dataTableCellStyle(hover, id)}>
                            {(page - 1) * 10 + id + 1}
                          </TableCell>
                          <TableCell style={dataTableCellStyle(hover, id)}>
                            {employee.name}
                          </TableCell>
                          <TableCell style={dataTableCellStyle(hover, id)}>
                            {employee.userId.email}
                          </TableCell>
                          <TableCell style={dataTableCellStyle(hover, id)}>
                            {employee.designation}
                          </TableCell>
                          <TableCell style={dataTableCellStyle(hover, id)}>
                            {employee.department}
                          </TableCell>
                          <TableCell style={dataTableCellStyle(hover, id)}>
                            {employee.cnic}
                          </TableCell>
                          <TableCell style={dataTableCellStyle(hover, id)}>
                            {employee.phone}
                          </TableCell>
                          <TableCell style={dataTableCellStyle(hover, id)}>
                            {employee.salary}
                          </TableCell>
                          <TableCell style={dataTableCellStyle(hover, id)}>
                            <IconButton
                              style={{
                                color: "#fff",
                                backgroundColor: "#1976D2",
                                marginRight: "5px",
                              }}
                              aria-label="view"
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                profile(employee._id, employee.userId._id);
                              }}
                            >
                              <VisibilityIcon fontSize="inherit" />
                            </IconButton>
                            <IconButton
                              style={{
                                color: "#fff",
                                backgroundColor: "#4CAF50",
                                marginRight: "5px",
                              }}
                              aria-label="edit"
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                selectEmployee(employee._id);
                              }}
                            >
                              <EditIcon fontSize="inherit" />
                            </IconButton>
                            <IconButton
                              style={{
                                color: "#fff",
                                backgroundColor: "#F44336",
                                marginRight: "5px",
                              }}
                              aria-label="delete"
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleClickOpen(employee._id);
                              }}
                            >
                              {employee.status === "active" ? (
                                <ArchiveIcon fontSize="inherit" />
                              ) : (
                                <UnarchiveIcon fontSize="inherit" />
                              )}
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                    <TableFooter
                      style={{ backgroundColor: "#1F1F1F" }}
                    >
                      <TableRow>
                        <TableCell
                          colSpan={100}
                          style={{ color: "white", border: "none", textAlign: 'center' }}
                        >
                          <Pagination
                            count={totalPages}
                            variant="outlined"
                            color="primary"
                            page={page}
                            onChange={(e, value)=>{setPage(value)}}
                            sx={{
                              display: 'inline-block',
                              "& .MuiPaginationItem-root": {
                                color: "#fff",
                                borderColor: "#fff",
                                transition: "all 0.3s ease",
                                "&:hover": {
                                  backgroundColor: "#FF5722",
                                  color: "#fff",
                                  borderColor: "#FF5722",
                                },
                                "&.Mui-selected": {
                                  backgroundColor: "#FF5722",
                                  color: "#fff",
                                  borderColor: "#FF5722",
                                },
                              },
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    </TableFooter>
                  </Table>
                </TableContainer>
              ) : (
                <Grid container spacing={1} justifyContent='center'>
                  {employees.map((employee, id) => (
                    <Grid item xs={12} key={id}>
                      <Card ref = {id+1 === employees.length ? ref : null}
                        sx={{
                          backgroundColor: "#101010",
                          color: "#fff",
                        }}
                        onMouseEnter={() => setHover(id)}
                        onMouseLeave={() => setHover(null)}
                        onClick={() =>
                          profile(employee._id, employee.userId._id)
                        }
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <CardContent>
                            <Typography variant="h5">
                              {employee.name}
                            </Typography>
                            <Typography variant="body2">
                              {employee.userId.email}
                              <br />
                              {employee.designation}
                            </Typography>
                          </CardContent>
                          <CardActions>
                            <IconButton
                              style={{
                                color: "#fff",
                                backgroundColor: "#1976D2",
                                marginRight: "1px",
                              }}
                              aria-label="view"
                              size="medium"
                              onClick={(e) => {
                                e.stopPropagation();
                                profile(employee._id, employee.userId._id);
                              }}
                            >
                              <VisibilityIcon fontSize="inherit" />
                            </IconButton>
                            <IconButton
                              style={{
                                color: "#fff",
                                backgroundColor: "#4CAF50",
                                marginRight: "1px",
                              }}
                              aria-label="edit"
                              size="medium"
                              onClick={(e) => {
                                e.stopPropagation();
                                selectEmployee(employee._id);
                              }}
                            >
                              <EditIcon fontSize="inherit" />
                            </IconButton>
                            <IconButton
                              style={{
                                color: "#fff",
                                backgroundColor: "#F44336",
                                marginRight: "1px",
                              }}
                              aria-label="delete"
                              size="medium"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleClickOpen(employee._id);
                              }}
                            >
                              {employee.status === "active" ? (
                                <ArchiveIcon fontSize="inherit" />
                              ) : (
                                <UnarchiveIcon fontSize="inherit" />
                              )}
                            </IconButton>
                          </CardActions>
                        </Box>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              )}
            </>
          )}
          <Modal open={openFilter} onClose={handleClose}>
            <Box
              sx={{
                position: "absolute",
                top: { xs: "50%", md: "50%" },
                right: { xs: "50%", md: "0" },
                transform: {
                  xs: "translate(50%, -50%)",
                  md: "translate(-20%, -50%)",
                },
                width: { xs: "80vw", md: 400 },
                height: "70vh",
                bgcolor: "#2d2d2b",
                color: "#fff",
                borderRadius: "10px",
                p: 3,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <Typography variant="h6">Filter</Typography>
                  <CloseIcon onClick={handleClose} sx={{ cursor: "pointer" }} />
                </Box>
                <Divider sx={{ my: 2, bgcolor: "#fff" }} />
                <Accordion
                  sx={{
                    bgcolor: "#2d2d2b",
                    color: "#fff",
                    boxShadow: "none",
                    "& .MuiAccordionSummary-root": {
                      bgcolor: "#2d2d2b",
                      color: "#fff",
                    },
                    "& .MuiAccordionDetails-root": {
                      bgcolor: "#2d2d2b",
                      color: "#fff",
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                  >
                    <Typography>Employee Status</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <FormControl component="fieldset">
                      <RadioGroup
                        row
                        aria-label="employee-status"
                        name="employee-status"
                        value={statusFilter}
                        onChange={handleStatusChange}
                      >
                        {statuses.map((status) => (
                          <FormControlLabel
                            key={status.value}
                            value={status.value}
                            control={
                              <Radio
                                sx={{
                                  color: "#fff",
                                  "&.Mui-checked": {
                                    color: "#FF5722",
                                  },
                                }}
                              />
                            }
                            label={status.label}
                          />
                        ))}
                      </RadioGroup>
                    </FormControl>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  sx={{
                    bgcolor: "#2d2d2b",
                    color: "#fff",
                    boxShadow: "none",
                    "& .MuiAccordionSummary-root": {
                      bgcolor: "#2d2d2b",
                      color: "#fff",
                    },
                    "& .MuiAccordionDetails-root": {
                      bgcolor: "#2d2d2b",
                      color: "#fff",
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                  >
                    <Typography>Salary Range</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box sx={{ bgcolor: "#2d2d2b", color: "#fff", p: 2 }}>
                      <Slider
                        value={salaryRange}
                        onChange={handleSliderChange}
                        valueLabelDisplay="auto"
                        min={10000}
                        max={500000}
                        step={5000}
                        getAriaValueText={formatLabel}
                        sx={{ color: "#FF5722" }}
                      />
                      <Typography color="#fff" variant="body1" mt={2}>
                        <b>Selected Range:</b>
                        {` ${formatLabel(salaryRange[0])} - ${formatLabel(
                          salaryRange[1]
                        )}`}
                      </Typography>
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </Box>

              <Box>
                <Divider sx={{ my: 2, bgcolor: "#fff" }} />
                <Button
                  variant="outlined"
                  color="error"
                  fullWidth
                  onClick={() => {
                    setStatusFilter("");
                    setSalaryRange([10000, 500000]);
                  }}
                >
                  Clear Filters
                </Button>
              </Box>
            </Box>
          </Modal>

          <Dialog
            open={open}
            sx={{
              "& .MuiPaper-root": {
                backgroundColor: "#212121",
                color: "#fff",
                padding: "15px",
              },
              "& .MuiDialogTitle-root": {
                padding: "5px",
              },
              "& .MuiDialogContentText-root": {
                color: "#fff",
              },
              "& .MuiDialogContent-root": {
                padding: "5px",
              },
              "& .MuiDialogActions-root": {
                padding: "5px",
              },
            }}
          >
            <DialogTitle>Confirm Deletion</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Are you sure you want to delete this employee?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleClose}
                sx={{
                  backgroundColor: "#A6A6A6",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#B8B8B8" },
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleDelete}
                sx={{
                  backgroundColor: "#E5622D",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#D0521B" },
                }}
              >
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
          <AddEmployee
            open={openModal}
            handleClose={handleClose}
            employeeId={updateId}
          />
        </div>
      </div>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {isSmallScreen && <Grid container width='100%' height='10vh' alignItems='center' justifyContent='center' style={{position: 'fixed', bottom: (isFetchingUser ? '20px' : '-100px'), transition: 'bottom 0.5s ease'}}>
        <CircularProgress size="3rem" sx={{color: "#FF5722"}} />
      </Grid>}
    </>
  );
};

export default Employees;
